import axios from 'axios';
import qs from 'qs';
import {serviceOptions} from './generated/index.defs';
import {Env} from '../config/env-vars';
import {requestInterceptors} from './request-interceptors';
import {handleResponseError} from './error-handlers';

export const instance = axios.create({
  baseURL: Env.apiBaseUrl,
  paramsSerializer: (params) => qs.stringify(params, {allowDots: true}),
});

instance.interceptors.request.use(requestInterceptors, Promise.reject);
instance.interceptors.response.use((x) => x, handleResponseError);

serviceOptions.axios = instance;